var ko = require('knockout'),
  analytics = require('_js/analytics-ecommerce'),
  filter = require('lodash/filter'),
  merge = require('lodash/merge');
require('knockout-postbox');

var CartVersion = 2;

var shoppingCart = function() {
  var cartKey = 'shoppingCart';
  var updateTopic = 'shoppingCartUpdated';

  var emptyCart = function() {
    localStorage.setItem(cartKey, '');

    var emptyCart = {
      owner: window.username,
      version: CartVersion,
      courses: [],
      payer: undefined,
      agency: undefined
    };
    ko.postbox.publish(updateTopic, emptyCart);
    return emptyCart;
  };

  var getCart = function() {
    var cart = localStorage.getItem(cartKey);
    if (cart === undefined || cart === null || cart === '') return emptyCart();

    var parsedCart = JSON.parse(cart);

    if (parsedCart.version !== CartVersion) return emptyCart();

    return parsedCart;
  };

  var storeCart = function(cart) {
    localStorage.setItem(cartKey, JSON.stringify(cart));
    ko.postbox.publish(updateTopic, getCart());
  };

  var validateCartOwner = function() {
    // Checks if current cart is actually owned by logged in user
    // Sets user as owner if logging in during the process
    var cart = getCart();

    var user = window.username;
    if (cart.owner === '') {
      cart.owner = user;
      storeCart(cart);
    } else if (cart.owner !== user) {
      emptyCart();
      ko.postbox.publish(updateTopic, getCart());
    }
  };

  var findCourseInCart = function(cart, courseId) {
    for (var x = 0; x < cart.courses.length; x++) {
      if (cart.courses[x].Id === courseId) {
        return cart.courses[x];
      }
    }
    return undefined;
  };

  var createCartCourse = function(course) {
    course.participants = [];
    course.AuditorCredits = filter(course.AuthorizationCredits, {
      AuthorizationType: 2
    });
    course.AccountantCredits = filter(course.AuthorizationCredits, {
      AuthorizationType: 1
    });
    return course;
  };

  var createCourseParticipant = function(participant) {
    return {
      AktorId: participant.AktorId,
      Name: participant.Name,
      Member: participant.MembershipType === 1
    };
  };

  var findParticipantInCourse = function(course, participantId) {
    for (var x = 0; x < course.participants.length; x++) {
      if (course.participants[x].AktorId === participantId) {
        return course.participants[x];
      }
    }
    return undefined;
  };

  var addCourseToCart = function(course, pageTypeName) {
    var cart = getCart();
    var existingCourse = findCourseInCart(cart, course.Id);

    if (existingCourse === undefined) {
      var cartCourse = createCartCourse(course);

      analytics.productAddedToCart(course, 0, undefined, pageTypeName);
      cart.courses.push(cartCourse);

      storeCart(cart);

      return cartCourse;
    }
    return existingCourse;
  };

  var removeCourseFromCart = function(courseId) {
    var cart = getCart();

    var course = findCourseInCart(cart, courseId);
    var index = cart.courses
      .map(function(c) {
        return c.Id;
      })
      .indexOf(courseId);
    if (index > -1) {
      cart.courses.splice(index, 1);

      var participants = course.participants.length;
      analytics.productRemovedFromCart(course, participants);
      ko.postbox.publish('removeCourse', course);
      ko.postbox.publish('removeCourseWithKey', course.Key);
      // ko.postbox.publish(updateTopic, getCart());
      storeCart(cart);
    }
  };

  var addParticipantToCourseNoStore = function(cart, courseId, participant) {
    var course = findCourseInCart(cart, courseId);
    if (course !== undefined) {
      var courseParticipant = createCourseParticipant(participant);
      var existingParticipant = findParticipantInCourse(
        course,
        courseParticipant.AktorId
      );
      if (existingParticipant === undefined) {
        course.participants.push(courseParticipant);
        //analytics.productAddedToCart(course, 1);
      }
    }
    return cart;
  };
  var addParticipantToCourse = function(courseId, participant) {
    var cart = getCart();
    cart = addParticipantToCourseNoStore(cart, courseId, participant);
    storeCart(cart);
  };

  var addParticipantsToCourse = function(
    courseId,
    participants,
    cart,
    noStore
  ) {
    cart = cart || getCart();

    for (var i = 0; i < participants.length; i++) {
      cart = addParticipantToCourseNoStore(cart, courseId, participants[i]);
    }

    if (!noStore) storeCart(cart);
    return cart;
  };

  var addParticipantsToCourses = function(courses, participants) {
    var cart = getCart();
    for (var x = 0; x < courses.length; x++) {
      if (courses[x].EventType == 6) {
        cart = addParticipantsToCourse(
          courses[x].Key,
          participants,
          cart,
          true
        );
      } else {
        cart = addParticipantsToCourse(courses[x].Id, participants, cart, true);
      }
    }
    storeCart(cart);
  };

  var removeParticipantFromCourse = function(courseId, participantId) {
    var cart = getCart();
    var course = findCourseInCart(cart, courseId);
    if (course !== undefined) {
      var index = course.participants
        .map(function(p) {
          return p.AktorId;
        })
        .indexOf(participantId);
      if (index > -1) {
        course.participants.splice(index, 1);

        analytics.productRemovedFromCart(course, 1);
        storeCart(cart);
        return;
      } else {
        return;
      }
    }
    throw 'Unknown course';
  };

  var isCourseAlreadyAdded = function(courseId) {
    var cart = getCart();
    var course = findCourseInCart(cart, courseId);
    return course !== undefined;
  };

  var updateAgency = function(newAgency) {
    var cart = getCart();

    // Will only update agency if newAgency.AktorId matches cart.agency.AktorId.
    if (newAgency && newAgency.AktorId === cart.agency.AktorId) {
      storeCart(merge({}, cart, { agency: newAgency }));
    }
  };
  var replaceAgency = function(newAgency) {
    var cart = getCart();
    if (
      cart.agency === undefined ||
      newAgency === undefined ||
      newAgency.AktorId !== cart.agency.AktorId
    ) {
      cart.agency = newAgency;
      //Warning, this removes all participants
      for (var i = 0; i < cart.courses.length; i++) {
        var course = cart.courses[i];
        analytics.productRemovedFromCart(course, course.participants.length);
        course.participants = [];
      }

      storeCart(cart);
    }
  };

  var isAgencySet = function() {
    var cart = getCart();
    return (
      cart.agency !== undefined &&
      cart.agency.AktorId !== undefined &&
      cart.agency.AktorId !== ''
    );
  };

  var replacePayer = function(newPayer) {
    var cart = getCart();
    cart.payer = newPayer;
    storeCart(cart);
  };

  var areDatesOverlapping = function(fromDate1, toDate1, fromDate2, toDate2) {
    // If any dates are 'falsy' the dates are not set. That means they are not overlapping.
    if (!fromDate1 || !toDate1 || !fromDate2 || !toDate2) {
      return false;
    }
    var fromDate1Ms = new Date(fromDate1).getTime(),
      toDate1Ms = new Date(toDate1).getTime(),
      fromDate2Ms = new Date(fromDate2).getTime(),
      toDate2Ms = new Date(toDate2).getTime();

    // If start date s
    return (
      (fromDate1Ms >= fromDate2Ms && fromDate1Ms < toDate2Ms) ||
      (toDate1Ms <= toDate2Ms && toDate1Ms > fromDate2Ms)
    );
  };

  var resetOverlappingCoursesForParticipants = function(
    updateParticipantTopic
  ) {
    var cart = getCart();
    for (var i = 0; i < cart.courses.length; i++) {
      cart.courses[i].overlappingParticipants = {};
      // cart.courses[i].participants = []; // commented out this line because summary page was missing all course participants
    }
    storeCart(cart);
    if (updateParticipantTopic) {
      ko.postbox.publish(updateParticipantTopic, cart.courses);
    }
  };

  var removeOverlappingCoursesForParticipants = function(
    courseId,
    participants,
    updateParticipantTopic
  ) {
    var cart = getCart();
    var course = findCourseInCart(cart, courseId);
    for (var i = 0; i < cart.courses.length; i++) {
      // Skip the course we are attempting to add participants to.
      if (cart.courses[i].Id === courseId) {
        continue;
      }
      // Loop through all the participants we want to add.
      for (var k = 0; k < participants.length; k++) {
        // If dates are overlapping we want to give an error message connected to this participant.
        if (
          areDatesOverlapping(
            course.Date,
            course.ToDate,
            cart.courses[i].Date,
            cart.courses[i].ToDate
          )
        ) {
          delete cart.courses[i].overlappingParticipants[
            participants[k].AktorId
          ];
        }
      }
    }
    if (updateParticipantTopic) {
      // Store the updated cart in localstorage without triggering the cart update topic.
      localStorage.setItem(cartKey, JSON.stringify(cart));
      ko.postbox.publish(updateParticipantTopic, cart.courses);
    }
  };

  var registerOverlappingCoursesForParticipants = function(
    courseId,
    participants,
    updateParticipantTopic
  ) {
    var cart = getCart();
    var course = findCourseInCart(cart, courseId);
    for (var i = 0; i < cart.courses.length; i++) {
      // Skip the course we are attempting to add participants to.
      if (cart.courses[i].Id === courseId) {
        continue;
      }
      // Loop through all the participants we want to add.
      for (var k = 0; k < participants.length; k++) {
        // If dates are overlapping we want to give an error message connected to this participant.
        if (
          areDatesOverlapping(
            course.Date,
            course.ToDate,
            cart.courses[i].Date,
            cart.courses[i].ToDate
          )
        ) {
          // Only create an empty set if it does not exist.
          if (typeof cart.courses[i].overlappingParticipants === 'undefined') {
            cart.courses[i].overlappingParticipants = {};
          }
          cart.courses[i].overlappingParticipants[participants[k].AktorId] =
            participants[k];
        }
      }
    }
    if (updateParticipantTopic) {
      // Store the updated cart in localstorage without triggering the cart update topic.
      localStorage.setItem(cartKey, JSON.stringify(cart));
      ko.postbox.publish(updateParticipantTopic, cart.courses);
    }
  };

  validateCartOwner();
  ko.postbox.publish(updateTopic, getCart());

  return {
    addCourseToCart: addCourseToCart,
    removeCourseFromCart: removeCourseFromCart,
    isCourseAlreadyAdded: isCourseAlreadyAdded,
    findCourseInCart: findCourseInCart,
    addParticipantToCourse: addParticipantToCourse,
    addParticipantsToCourse: addParticipantsToCourse,
    addParticipantsToCourses: addParticipantsToCourses,
    removeParticipantFromCourse: removeParticipantFromCourse,
    removeOverlappingCoursesForParticipants: removeOverlappingCoursesForParticipants,
    registerOverlappingCoursesForParticipants: registerOverlappingCoursesForParticipants,
    resetOverlappingCoursesForParticipants: resetOverlappingCoursesForParticipants,

    replaceAgency: replaceAgency, //Removes all participants
    updateAgency: updateAgency, // Updates agency without removing participants
    isAgencySet: isAgencySet,

    replacePayer: replacePayer,

    emptyCart: emptyCart,
    getCart: getCart,

    updateTopic: updateTopic
  };
};

var newShoppingCart = shoppingCart();
window.regnskapnorge.shoppingCart = newShoppingCart;
module.exports = newShoppingCart;
